import { deleteLocalStorageAuth } from 'utils/local-storage';
import {
  activateAccount,
  defaultLabelForEmail,
  getAccounts,
  getActiveAccountConfig,
  getAddReturnClient,
  setAddingAccount,
  setAddReturnClient,
  uniqueLabel,
  upsertAccount,
} from './accounts';

export const startAddAccount = (
  email: string,
  redirect: (url: string) => void = (url) => {
    window.location.href = url;
  },
): void => {
  const current = getActiveAccountConfig(email);
  if (current) {
    // Preserve a label the user already chose; only fall back to a (unique) default for a
    // fresh snapshot, appending a number if the default is already used by another account.
    const accounts = getAccounts();
    const existing = accounts.find((a) => a.clientId === current.clientId);
    const taken = accounts.filter((a) => a.clientId !== current.clientId).map((a) => a.label);
    const label = existing?.label ?? uniqueLabel(defaultLabelForEmail(email), taken);
    upsertAccount({ ...current, label });
    setAddReturnClient(current.clientId);
  }
  setAddingAccount(true);
  // Clear the active Amplify config so /login boots with a clean auth state. Otherwise the
  // still-cached current session makes the Authenticator show "You are already signed in".
  // The previous pool's tokens stay in localStorage (namespaced by clientId), so switching
  // back still works, and cancelAddAccount restores the active config.
  deleteLocalStorageAuth();
  redirect('/login');
};

export const cancelAddAccount = (
  reload: () => void = () => {
    window.location.reload();
  },
): void => {
  const returnClient = getAddReturnClient();
  setAddingAccount(false); // also clears the return-client pointer
  if (returnClient) {
    const prev = getAccounts().find((a) => a.clientId === returnClient);
    if (prev) activateAccount(prev);
  }
  reload();
};
